import { createRouter, createWebHistory } from 'vue-router'
import showLoginOrRegPopup from '@a/components/showLoginOrRegPopup'
import { useUserInfo } from '@/store'
// import i18n from '@/i18n'
import GooglePage from '@/views/__template/index.vue'
import useFromAndTo from "@/hooks/useFromAndTo";
import Maintain from '@/views/__Maintain/index.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',  redirect: '/home'
    },
    {
      path: '/template',
      name: 'template',
      component: GooglePage
    },{
      path: '/maintain',
      name: 'maintain',
      component: Maintain
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  useFromAndTo(to, from)

  if (useUserInfo().isLoggedin) {
    if (to.path === '/login' || to.path === '/reg') {
      next({ path: '/home', replace: true })
    } else next()
  } else {
    const needCheckLogin = to.meta.needLogin
    if (needCheckLogin) {
      if (from.path === to.path || to.path == '/meu' || from.query.pwaredirect) {
        next({ path: '/login', query: { from: to.fullPath } })
      } else {
        if (from.path == '/login' || from.path == '/reg') {
          next({ path: '/home', replace: true })
        } else {
          showLoginOrRegPopup()
        }
      }
    } else next()
  }
})

export default router
